"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentsByIds = exports.attachRootContent = exports.attachContentVersionLogToRootContent = void 0;
const tslib_1 = require("tslib");
const concat_1 = tslib_1.__importDefault(require("lodash/concat"));
const flatten_1 = tslib_1.__importDefault(require("lodash/flatten"));
const groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
const __enums_1 = require("../../__types/__enums");
const cache_1 = require("../__common/cache");
const contentQueryHelper_1 = require("./common/contentQueryHelper");
function getCachedDataFromIds(rp, Ids) {
    const cachedData = [];
    const uncachedIds = [];
    Ids.forEach(id => {
        const content = cache_1.getFromCache(rp, id);
        if (content) {
            cachedData.push(content);
        }
        else {
            uncachedIds.push(id);
        }
    });
    return { cachedData, uncachedIds };
}
function attachContentVersionLogToRootContent(rp, contents) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { cachedData: cachedContentVersionLogContents, uncachedIds: uncachedContentVersionLogContentIds } = getCachedDataFromIds(rp, uniq_1.default(contents.map(content => `contentVersionLog_${content.rootContentId}`)));
        let remainingContentVersionLogs = [];
        if (uncachedContentVersionLogContentIds.length > 0) {
            const filters = [
                {
                    name: __enums_1.ContentFilterEnum.CONTENT_ID,
                    type: __enums_1.ElasticsearchFilterTypeEnum.MUST,
                    values: uncachedContentVersionLogContentIds.map(id => id.split('_')[1])
                }
            ];
            const reportResult = yield rp.getContentVersionLogReports({
                ReportParams: {
                    filters: {
                        contentVersionLogFilters: filters
                    },
                    requestType: __enums_1.ReportRequestTypeEnum.ALL
                },
                SortParams: [
                    {
                        field: __enums_1.ContentVersionLogSortFieldEnum.CREATED_AT,
                        order: __enums_1.SortOrderEnum.ASCENDING
                    }
                ]
            });
            remainingContentVersionLogs = reportResult.reports.map((doc) => doc.contentVersionLog);
            remainingContentVersionLogs.forEach((contentVersionLog) => {
                const cacheObject = cache_1.getFromCache(rp, `contentVersionLog_${contentVersionLog.contentId}`) || [];
                cache_1.putIntoCache(rp, `contentVersionLog_${contentVersionLog.contentId}`, cacheObject.concat([contentVersionLog]));
            });
        }
        const contentVersionLogsByContentId = groupBy_1.default(concat_1.default(flatten_1.default(cachedContentVersionLogContents), remainingContentVersionLogs), 'contentId');
        contents.forEach(content => {
            content.contentVersionLogs = contentVersionLogsByContentId[content.rootContentId];
        });
    });
}
exports.attachContentVersionLogToRootContent = attachContentVersionLogToRootContent;
const isRootContent = (content) => content.rootContentId && content.rootContentId !== content.contentId;
function attachRootContent(rp, contents) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let rootContentIds = [];
        contents.forEach(content => {
            if (isRootContent(content)) {
                rootContentIds.push(content.rootContentId);
            }
        });
        rootContentIds = uniq_1.default(rootContentIds);
        const { cachedData: cachedContents, uncachedIds: uncachedContentIds } = getCachedDataFromIds(rp, rootContentIds);
        let rootContents = cachedContents;
        if (uncachedContentIds.length > 0) {
            const filters = [
                { name: __enums_1.CommonFilterEnum.ID, type: __enums_1.ElasticsearchFilterTypeEnum.MUST, values: uncachedContentIds }
            ];
            const remainingContents = yield contentQueryHelper_1.loadContentsFromContentIds(filters);
            remainingContents.forEach((content) => cache_1.putIntoCache(rp, content._id, content));
            rootContents = rootContents.concat(remainingContents);
        }
        const rootContentsByContentId = keyBy_1.default(rootContents, 'id');
        contents.forEach(content => {
            content.rootContent = rootContentsByContentId[content.rootContentId];
        });
    });
}
exports.attachRootContent = attachRootContent;
function getContentsByIds(rp, filters, withRootContent, attachContentVersionLog) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let contentIds = filters[0].values;
        contentIds = uniq_1.default(contentIds);
        const { cachedData: cachedContents, uncachedIds: uncachedContentIds } = getCachedDataFromIds(rp, contentIds);
        let contents = cachedContents;
        if (uncachedContentIds.length > 0) {
            filters[0].values = uncachedContentIds;
            const remainingContents = yield contentQueryHelper_1.loadContentsFromContentIds(filters);
            remainingContents.map((content) => cache_1.putIntoCache(rp, content._id, content));
            contents = cachedContents.concat(remainingContents);
        }
        const promises = [];
        if (withRootContent) {
            promises.push(attachRootContent(rp, contents));
        }
        if (attachContentVersionLog) {
            promises.push(attachContentVersionLogToRootContent(rp, contents));
        }
        yield Promise.all(promises);
        return { contents, total: contents.length };
    });
}
exports.getContentsByIds = getContentsByIds;
//# sourceMappingURL=getContentsByIds.js.map